export default class CompoAddCoef {
    constructor(data = {}) {
        this.id = data.id || null;
        this.idCompo = data.idCompo;
        this.idAddition = data.idAddition;
        this.coefK = data.coefK;
        this.selected = data.selected;
    }
}
